/**
 * This custom error should be used to wrap any error that is thrown in the application.
 * This way we can define the name of the error when we are sending it to sentry without having to create
 * a custom error for each error type that we want to send to sentry.
 * e.g. instead of creating a class for each type
 * class ShippingRatesError extends Error { ... } or class GetAddressSuggestionDetailsError extends Error { ... }
 * we can just use this class and pass the name of the error as a parameter.
 * i.e. new CustomError('ShippingRatesError', error) or new CustomError('GetAddressSuggestionDetailsError', error)
 */
export class CustomError extends Error {
  constructor(name: string, error: Error) {
    super(error.message);

    this.name = `${name}Error` || error.name; // we'll append 'Error' to the name being passed
    this.stack = error.stack; // we'll keep the original stack trace

    // this allows for `instanceof CustomError` and `instanceof Error` to work
    Object.setPrototypeOf(this, CustomError.prototype);
  }
}
